<template>
  <el-form :model="company" label-width="120px">
    <el-form-item label="公司名称">
      <el-input v-model="company.name" />
    </el-form-item>
    <el-form-item label="法定代表人">
      <el-input v-model="company.fr" />
    </el-form-item>
    <el-form-item label="注册资本">
      <el-input v-model="company.zczb" />
    </el-form-item>
    <el-form-item label="信用代码">
      <el-input v-model="company.xydm" />
    </el-form-item>
    <el-form-item label="住所">
      <el-input v-model="company.zs" type="textarea" />
    </el-form-item>
    <el-form-item label="成立日期">
      <el-date-picker
        v-model="company.clrq"
        type="date"
        placeholder="选择日期"
        value-format="yyyy-MM-dd"
      />
    </el-form-item>
    <el-form-item label="营业期限">
      <el-input v-model="company.yyqx" />
    </el-form-item>
    <el-form-item label="类型">
      <el-input v-model="company.cType" />
    </el-form-item>
    <el-form-item label="经营范围">
      <el-input v-model="company.jyfw" type="textarea" />
    </el-form-item>
    <el-form-item label="进驻日期">
      <el-date-picker
        v-model="company.jzrq"
        type="date"
        placeholder="选择日期"
        value-format="yyyy-MM-dd"
      />
    </el-form-item>
<!--    <el-form-item label="是否封存">-->
<!--      <el-switch v-model="company.close" />-->
<!--    </el-form-item>-->
    <el-form-item>
      <el-button type="primary" @click="onSubmit">保存</el-button>
      <el-button>清空</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
export default {
  props: ['company', 'isNew'],
  methods: {
    onSubmit () {
      // console.log(this.company)
      if (!this.company.name) {
        this.$message.error('公司名称不能为空')
        return false
      }
      this.$http.post(this.apiUrl + '/sys/save', this.company)
        .then((response, result) => {
          // console.log(response, result)
          if (response.status === 200 && response.data && response.data.affectedRows > 0) {
            this.$message({
              message: '保存成功',
              type: 'success'
            })
            if (this.isNew) {
              // this.$alert('是否继续添加知识产权内容', '提示', {
              //   confirmButtonText: '确定',
              //   callback: action => {
              //   }
              // })
            }
            this.$emit('saveSuccess', response.data.insertId)
          } else {
            this.$message.error('保存失败')
          }
        })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/company.vue